// Module
var code = "<md-slider-container>\n    <md-slider flex md-discrete ng-model=\"vm.luminosite\" step=\"1\" min=\"1\" max=\"10\" aria-label=\"rating\" ng-change=\"vm.brightness()\"></md-slider>\n</md-slider-container>";
// Exports
module.exports = code;